import { APPEND_PRODUCT_SALES_STATISTICS, RE_INITIALIZE_PRODUCT_SALES_STATISTICS_FILTER, SET_PRODUCT_SALES_CATEGORIES, SET_PRODUCT_SALES_STATISTICS, SET_PRODUCT_SALES_STATISTICS_FILTER, SET_PRODUCT_SALES_STATISTICS_FILTER_READY, SET_PRODUCT_SALES_STATISTICS_IS_LOADED, SET_PRODUCT_SALES_STATISTICS_TOTAL_LENGTH } from '../../actionTypes/productSalesStatistic'
import { NET_PRICE_TYPE } from './constants'

const initialState = {
	productSalesFilter: {
		dateFrom: new Date(),
		dateTo: new Date(),
		searchText: '',
		productType: null,
		categoryId: null,
		orderByType: 'QUANTITY',
		orderByAsc: false,
		priceType: NET_PRICE_TYPE
	},
	productSalesIsLoaded: false,
	productSales: [],
	productSalesTotalLength: 0,
	productSalesFilterReady: false,
	categories: []
}

export function productSalesStatisticReducer (state = initialState, action) {
	switch (action.type) {
		case RE_INITIALIZE_PRODUCT_SALES_STATISTICS_FILTER:
			return {
				...state,
				productSalesFilter: {
					...initialState.productSalesFilter,
					dateFrom: new Date(),
					dateTo: new Date(),
				},
			}
		case SET_PRODUCT_SALES_STATISTICS_FILTER:
			return {
				...state,
				productSalesFilter: {
					...state.productSalesFilter,
					...action.value,
				},
			}
		case SET_PRODUCT_SALES_STATISTICS_IS_LOADED:
			return {
				...state,
				productSalesIsLoaded: action.value,
			}
		case SET_PRODUCT_SALES_STATISTICS:
			return {
				...state,
				productSales: action.value,
			}
		case APPEND_PRODUCT_SALES_STATISTICS:
			return {
				...state,
				productSales: state.productSales.concat(...action.value),
			}
		case SET_PRODUCT_SALES_STATISTICS_TOTAL_LENGTH:
			return {
				...state,
				productSalesTotalLength: action.value,
			}
		case SET_PRODUCT_SALES_STATISTICS_FILTER_READY:
			return {
				...state,
				productSalesFilterReady: action.value,
			}
	case SET_PRODUCT_SALES_CATEGORIES:
			return {
				...state,
				categories: action.value,
			}
		default:
			return state
	}
}
